module.exports = __webpack_public_path__ + "img/product3.a001377b.jpg";